import { Media } from "./media";

export interface VideoTag {
    id: number;
    name: string;
    created_by?: number;
    created_at?: string;
}

export interface Video {
    id: number;
    name: string;
    description: string;
    media: Media[];
    tags: VideoTag[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyVideo: Video = {
    id: 0,
    name: '',
    description: '',
    media: [],
    tags: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}